export default "__VITE_ASSET__CsYclFG9__"